<template>
  <div class="container-fluid py-2">
    <h3 class="pb-2 border-bottom">Rechercher une personne <b-icon-person-circle></b-icon-person-circle></h3>

    <form class="zsearch row">
      <div class="col-12 col-md-6 py-2">
        <label for="sn">Nom</label>
        <div class="input-group mb-3">
          <input id="sn" v-model="sn" type="text" class="form-control" placeholder="Nom" aria-label="Nom" aria-describedby="btn-search-sn">
          <button class="btn btn-success" type="button" id="btn-search-sn" v-on:click="searchSn()">Rechercher</button>
        </div>
      </div>
      <div class="col-12 col-md-6 py-2">
        <label for="givenname">Prénom</label>
        <div class="input-group mb-3">
          <input id="givenname" v-model="givenname" type="text" class="form-control" placeholder="Prénom" aria-label="Prénom" aria-describedby="btn-search-givenname">
          <button class="btn btn-success" type="button" id="btn-search-givenname" v-on:click="searchGn()">Rechercher</button>
        </div>
      </div>
      <div class="col-12 py-2">
        <b-button v-b-toggle.collapse-1 variant="primary">
          <b-icon-house-fill></b-icon-house-fill> &nbsp;Rechercher par Ecole/Service
        </b-button>
        <b-collapse id="collapse-1" class="mt-2">
          <!-- Test à finaliser (EM) -->
          <!-- <b-card>
            <b-form-select v-model="selected">
              <option class="niveau3" v-for="(child, index) in inpTree2" :key="index" :value="child.name" v-on:click="searchUnit(child.name)">
                {{ child.label }}
              </option>
            </b-form-select>
            <div class="mt-3">Selected: <strong>{{ selected }}</strong></div>
          </b-card> -->

          <!-- Affichage des données issues de Cocktail via annuaireweb.pm (EM) -->
          <!-- <b-card>
            <p>Veuillez cliquer sur un service ou une école pour filtrer...</p>
            <select name="" id="" v-html="results">
            </select>
          </b-card> -->
          
          <!-- Affichage des données issues du JSON (EM) -->
          <!-- Test : inpTree2 ou inpTreeTmp.children ? (EM) -->
          <b-card>
            <p>Veuillez cliquer sur un service ou une école pour filtrer...</p>
            <ul v-for="(child, index) in inpTree2" :key="index">
              <li :value="child.name" :key="child.id">
                <a v-on:click.prevent="searchUnit(child.name)" v-b-toggle.collapse-1 class="btn btn-link">
                  {{ child.label }}
                </a>
              </li>
              <ul v-for="(child2, index2) in child.children" :key="index2">
                <li :value="child2.name" :key="child2.name">
                  <a v-on:click.prevent="searchUnit(child2.name)" v-b-toggle.collapse-1 class="btn btn-link">
                    <b-icon-align-start></b-icon-align-start> {{ child2.label }}
                  </a>
                </li>
                <ul v-for="(child3, index3) in child2.children" :key="index3">
                  <li :value="child3.name" :key="child3.name">
                    <a v-on:click.prevent="searchUnit(child3.name)" v-b-toggle.collapse-1 class="btn btn-link">
                      <b-icon-align-start></b-icon-align-start> {{ child3.label }}
                    </a>
                  </li>
                  <ul v-for="(child4, index4) in child3.children" :key="index4">
                    <li :value="child4.name" :key="child4.name">
                      <a v-on:click.prevent="searchUnit(child4.name)" v-b-toggle.collapse-1 class="btn btn-link">
                        <b-icon-align-start></b-icon-align-start> {{ child4.label }}
                      </a>
                    </li>
                  </ul>
                </ul>
              </ul>
            </ul>
          </b-card>
        </b-collapse>
      </div>
    </form>

    <!-- <div class="zresults row">
      <div class="col py-2">
        <h3>Résultats from LDAP <b-icon-clipboard></b-icon-clipboard></h3>
        <div id="results" ref="results">
          <PersCard v-for="(result, index) in results.data" :key="index" :itemid="index" :attributes="result" :sn="sn"></PersCard>
        </div>
      </div>
    </div>
    <div class="zresults row">
      <div class="col py-2">
        <h3>Résultats from Cocktail <b-icon-clipboard></b-icon-clipboard></h3>
        <div id="resultsUnit" ref="resultsUnit">
          <p>{{ unit }}</p>
          <PersCard v-for="(result, index) in resultsUnit" :key="index" :itemid="index" :attributes="result" :sn="result.sn"></PersCard>
        </div>
      </div>
    </div> -->
    <div class="zresults row">
      <div class="col py-2">
        <h3>Résultats <b-icon-clipboard></b-icon-clipboard></h3>
        <div id="resultsFinal" ref="resultsFinal">
          <p v-if="flagSearchUnit">{{ unit }}</p>
          <PersCard v-for="(result, index) in resultsFinal" :key="index" :itemid="index" :attributes="result" :sn="sn"></PersCard>
        </div>
      </div>
    </div>
  </div>

</template>

<script>

import { BButton, BCollapse, BCard, } from 'bootstrap-vue'
import { BIconPersonCircle, BIconHouseFill, BIconClipboard, BIconAlignStart } from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import { VBToggle } from 'bootstrap-vue'
import Vue from 'vue'
Vue.directive('b-toggle', VBToggle)

import axios from 'axios'

import PersCard from './PersCard.vue'

export default {
  name: "Annuaire-Inp",
  components: {
    PersCard,
    BButton, BCollapse, BCard,
    BIconPersonCircle, BIconHouseFill, BIconClipboard, BIconAlignStart
  },
  data () {
    return {
      success: false,
      error: false,
      loading: false,
      directory: "People",
      sn: "",
      givenname: "",
      results: [],
      inpTreeTmp: {
        "id": 0,
        "name": "bordeaux inp",
        "label": "Bordeaux INP",
        "children": [
          { "id": 26, "name": "ag.comptable", "label": "Agence comptable", "children": [] },
          { "id": 1010, "name": "dgs", "label": "Direction Générale des Services", "children": [
          { "id": 8516, "name": "accueil", "label": "Accueil", "children": [] },
          { "id": 7108, "name": "dgs/affaires scientifiques", "label": "Affaires scientifiques", "children": [] },
          { "id": 3367, "name": "dgs/cap", "label": "Cellule Appui Au Pilotage", "children": [] },
          { "id": 3371, "name": "dgs/com", "label": "Service Communication", "children": [] },
          { "id": 7109, "name": "dgs/conseiller de prevention", "label": "Conseiller de prévention", "children": [] },
          { "id": 11342, "name": "dgs/coordination formation", "label": "Service Coordination Formation Scolarité", "children": [] },
          { "id": 2204, "name": "dgs/df", "label": "Direction Financière", "children": [] },
          { "id": 2208, "name": "dgs/dpi", "label": "Direction du Patrimoine Immobilier", "children": [
            { "id": 7148, "name": "dgs/dpi/site enscbp", "label": "DPI - ENSCBP", "children": [] },
            { "id": 7149, "name": "dgs/dpi/site enseirb-matmeca", "label": "DPI - ENSEIRB MatMéca", "children": [] }
          ] },
          { "id": 2205, "name": "dgs/drh", "label": "Direction des Ressources Humaines", "children": [] },
          { "id": 3366, "name": "dgs/dsi", "label": "Direction du Système d'Information", "children": [] },
          { "id": 3369, "name": "dgs/juridique", "label": "Service Juridique", "children": [] },
          { "id": 3368, "name": "dgs/mp", "label": "Médecine De Prévention", "children": [] },
          { "id": 7107, "name": "dgs/pole formation", "label": "Pôle Formation", "children": [] }
          ] },  
          { "id": 5435, "name": "prepa", "label": "La Prépa des INP", "children": [
          { "id": 7110, "name": "prepa/scol", "label": "Scolarité", "children": [] },
          { "id": 7111, "name": "prepa/tp", "label": "Prépa TP", "children": [] }
          ] },
          { "id": 38, "name": "ensc", "label": "ENSC - Ecole Nationale Supérieure de Cognitique", "children": [
          { "id": 7266, "name": "ensc/admin", "label": "Administration", "children": [] },
          { "id": 6969, "name": "ensc/logistique", "label": "Logistique", "children": [] },
          { "id": 7265, "name": "ensc/scolarite", "label": "Scolarité", "children": [] },
          { "id": 7267, "name": "ensc/transfert", "label": "Transfert", "children": [
            { "id": 7017, "name": "ensc/chaire ind. stah", "label": "Chair Inductrielle STAH", "children": [] }
          ] }
          ] },
          { "id": 3, "name": "enscbp", "label": "ENSMAC - Ecole Nationale Supérieure De Matériaux, d'Agroalimentaire et de Chimie", "children": [
          { "id": 6975, "name": "enscbp/com", "label": "Service Communication", "children": [] },
          { "id": 7018, "name": "enscbp/dir", "label": "Direction", "children": [] },
          { "id": 7020, "name": "enscbp/dir.etudes", "label": "Direction des études", "children": [
            { "id": 6976, "name": "enscbp/fc", "label": "Formation Continue", "children": [] },
            { "id": 7021, "name": "enscbp/gest.tp", "label": "Gestion des TP", "children": [] },
            { "id": 3834, "name": "enscbp/scol", "label": "Scolarité", "children": [] },
            { "id": 7561, "name": "enscbp/stages", "label": "Stages", "children": [] }
          ] },
          { "id": 7022, "name": "enscbp/dir.part.indus.", "label": "Direction du Partenariat Industriel", "children": [] },
          { "id": 7019, "name": "enscbp/dir.ri", "label": "Direction des Relations Internationales", "children": [] },
          { "id": 6974, "name": "enscbp/env.secu", "label": "Environnement et Sécurité", "children": [] },
          { "id": 2209, "name": "enscbp/interieur", "label": "Intérieur", "children": [] },
          { "id": 7115, "name": "enscbp/qual", "label": "Qualité", "children": [] }
          ] },
          { "id": 2965, "name": "ensegid", "label": "ENSEGID - Ecole Nationale Supérieure en Environnement Géoressources Et Ingénierie Du Développement Durable", "children": [
          { "id": 7258, "name": "ensegid/admin", "label": "Administration", "children": [
            { "id": 3913, "name": "ensegid/biblio", "label": "Bibliothèque", "children": [] },
            { "id": 6968, "name": "ensegid/entretien", "label": "Entretien", "children": [] },
            { "id": 6967, "name": "ensegid/serv.adm", "label": "Services Administratifs", "children": [
            { "id": 6966, "name": "ensegid/com", "label": "Service Communication", "children": [] },
            { "id": 3911, "name": "ensegid/scol", "label": "Scolarité", "children": [] }
            ] }
          ] },
          { "id": 7015, "name": "ensegid/labotp", "label": "Laboratoire TP", "children": [] }
          ] },
          { "id": 4, "name": "enseirb-matmeca", "label": "ENSEIRB MatMéca - Ecole Nationale Supérieure D'électronique, Informatique, Telecom., Maths Et Méca. De Bordeaux", "children": [
          { "id": 3843, "name": "em/com", "label": "Service Communication", "children": [] },
          { "id": 3842, "name": "em/cr docu", "label": "Centre de Documentation", "children": [] },
          { "id": 3840, "name": "em/craps", "label": "Centre de Ressources en Activités Physiques et Sportives", "children": [] },
          { "id": 3849, "name": "em/crege", "label": "Centre de Ressources en Economie et Gestion", "children": [] },
          { "id": 3841, "name": "em/crel", "label": "Centre de Ressources en Langues", "children": [] },
          { "id": 3845, "name": "em/dir. rel.ent.", "label": "Direction de la Relation Entreprises", "children": [] },
          { "id": 3839, "name": "em/direction", "label": "Direction", "children": [] },
          { "id": 3838, "name": "em/dir.etudes", "label": "Direction des études", "children": [
            { "id": 3847, "name": "em/scol", "label": "Scolarité", "children": [] }
          ] },
          { "id": 7011, "name": "em/dir.rech.transf.", "label": "Direction de la Recherche & Transfert", "children": [] },
          { "id": 3846, "name": "em/dir.ri", "label": "Direction des Relations Internationales", "children": [] },
          { "id": 8592, "name": "em/dpt altern", "label": "Département Alternance", "children": [
            { "id": 3850, "name": "em/dpt rsi", "label": "Département Réseaux Et Systèmes D'information", "children": [] },
            { "id": 3851, "name": "em/dpt see", "label": "Département Systèmes Electroniques Embarqués", "children": [] }
          ] },
          { "id": 2210, "name": "em/dpt élec", "label": "Département d'Electronique", "children": [] },
          { "id": 2206, "name": "em/dpt info", "label": "Département d'Informatique", "children": [] },
          { "id": 3837, "name": "em/dpt matmeca", "label": "Département MatMéca", "children": [] },
          { "id": 2211, "name": "em/dpt télécom", "label": "Département Télécommunication", "children": [] },
          { "id": 3844, "name": "em/enquetes", "label": "Enquêtes", "children": [] },
          { "id": 10703, "name": "em/fc", "label": "Formation continue", "children": [] },
          { "id": 2207, "name": "em/interieur", "label": "Intérieur", "children": [] },
          { "id": 7113, "name": "em/qual", "label": "Qualité", "children": [] }
          ] },
          { "id": 8811, "name": "enspima", "label": "ENSPIMA - Ecole Nationale Supérieure pour la Performance Industrielle et la Maintenance Aéronautique", "children": [
          { "id": 9008, "name": "enspima/scolarite", "label": "Scolarité", "children": [] }
          ] },
          { "id": 22, "name": "enstbb", "label": "ENSTBB - Ecole Nationale Supérieure de Technologie des Biomolécules de Bordeaux", "children": [
          { "id": 7270, "name": "enstbb/admin", "label": "Administration", "children": [] },
          { "id": 3829, "name": "enstbb/entretien", "label": "Entretien", "children": [] },
          { "id": 3832, "name": "enstbb/gestion", "label": "Gestion", "children": [] },
          { "id": 3827, "name": "enstbb/sanofi", "label": "Sanofi", "children": [] },
          { "id": 3831, "name": "enstbb/scol", "label": "Scolarité", "children": [] }
          ] },
          { "id": 7387, "name": "action", "label": "Actions For Oncogenesis Understanding And Target Identification In Oncology", "children": [] },
          { "id": 7423, "name": "alysai", "label": "Activation Du Lymphocite T, Surveillance Du Stress Et Auto Immunité", "children": [] },
          { "id": 8254, "name": "bmgic", "label": "Biothérapie Des Maladies Génétiques Inflammatoires Et Cancers", "children": [] },
          { "id": 24, "name": "bprvs", "label": "Biotechnologie Des Protéines Recombinantes A Visée Santé", "children": [] },
          { "id": 2276, "name": "cbmn", "label": "Chimie Et Biologie Des Membranes Et Des Nanoobjets", "children": [
          { "id": 8536, "name": "cbmn/biatss", "label": "CBMN BIATSS", "children": [] }
          ] },
          { "id": 3212, "name": "cirid", "label": "Composantes Innées De La Réponse Immunitaire Et Différenciation", "children": [] },
          { "id": 5912, "name": "climas", "label": "Cultures Et Litteratures Des Mondes Anglophones", "children": [] },
          { "id": 10436, "name": "epc makutu", "label": "Equipe Projet Commun Makutu (INRIA)", "children": [] },
          { "id": 3197, "name": "epoc", "label": "UMR EPOC - Environnements et Paléoenvironnements Océaniques et Continentaux", "children": [
          { "id": 10219, "name": "epoc/biatss", "label": "EPOC BIATSS", "children": [] }
          ] },
          { "id": 3853, "name": "g&e", "label": "Géoressources & Environnement", "children": [
          { "id": 8534, "name": "g&e/biatss", "label": "G&E BIATSS", "children": [] }
          ] },
          { "id": 3193, "name": "icmcb", "label": "Institut de Chimie de la Matière Condensée de Bordeaux", "children": [
          { "id": 8537, "name": "icmcb/biatss", "label": "ICMCB BIATSS", "children": [] }
          ] },
          { "id": 20, "name": "imb", "label": "Institut de Mathématiques de Bordeaux", "children": [] },
          { "id": 19, "name": "ims", "label": "Laboratoire Intégration du Matériau au Système", "children": [
          { "id": 8556, "name": "ims/biatss", "label": "IMS BIATSS", "children": [] }
          ] },
          { "id": 3211, "name": "incia", "label": "INCIA", "children": [] },
          { "id": 35, "name": "ism", "label": "Institut des Sciences Moléculaires", "children": [
          { "id": 8539, "name": "ism/biatss", "label": "ISM BIATSS", "children": [] }
          ] },
          { "id": 30, "name": "i2m", "label": "Institut de Mécanique et d'Ingénierie de Bordeaux Activités", "children": [
          { "id": 8538, "name": "i2m/biatss", "label": "I2M BIATSS", "children": [] }
          ] },
          { "id": 18, "name": "labri", "label": "Laboratoire Bordelais de Recherche en Informatique", "children": [
          { "id": 8541, "name": "labri/biatss", "label": "LaBRI  BIATSS", "children": [] }
          ] },
          { "id": 3201, "name": "lbm", "label": "Laboratoire De Biogénèse Membranaire", "children": [] },
          { "id": 33, "name": "lcpo", "label": "Laboratoire de Chimie des Polymères Organiques", "children": [
          { "id": 8542, "name": "lcpo/biatss", "label": "LCPO BIATSS", "children": [] }
          ] },
          { "id": 3200, "name": "lcts", "label": "Laboratoire Des Composites ThermoStructuraux", "children": [] },
          { "id": 3202, "name": "mcmp", "label": "Microbiologie Cellulaire Et Moléculaire Et Pathogénicite", "children": [] },
          { "id": 7422, "name": "mfp", "label": "Laboratoire De Microbiologie Fondamentale Et Pathogénicite", "children": [] },
          { "id": 8240, "name": "mfp", "label": "Microbiologie Fondamentale Et Pathogénécite", "children": [] },
          { "id": 3205, "name": "nutrineuro", "label": "Nutrition et Neurobiologie intégrative", "children": [
          { "id": 8530, "name": "nutrineuro/biatss", "label": "Nutri. Neuro. BIATSS", "children": [] }
          ] },
          { "id": 2278, "name": "oeno", "label": "Unité de recherche Œnologie", "children": [] },
          { "id": 8238, "name": "passages", "label": "Passage UMR 5319", "children": [] },
          { "id": 7898, "name": "scrime", "label": "Studio de Création et de Recherche en Informatique et Musiques Expérimentales", "children": [] }
        ]
      },
      inpTree: null,
      inpTree2: [],
      search: '',

      resultsUnit: [],
      resultsFinal: [],
      flagSearchUnit: false,
      prod: true,
      unit: null
    }
  },
  computed: {
    filteredItems () { // Non utilisé ? (EM)
      //console.log("filteredItems")
      if (this.inpTree2) {
        return this.inpTree2.filter(item => {
          return item.label.toLowerCase().indexOf(this.search.toLowerCase()) > -1
        })
      } else {
        return []
      }
    }
  },
  watch: { 
    inpTree (newVal, oldVal) {
      // console.log("inpTree (watch)")

      if (this.prod) {
        // Production
        console.log('Production mode (watch)')
        this.inpTree2 = this.inpTree.data.children
      }
      else {
        // Development 
        console.log('Development mode (watch)')
        this.inpTree2 = this.inpTreeTmp.children
      }
      
      console.log("prod : " + this.prod)
      //console.log(this.inpTree2)

      if (newVal !== oldVal) {
        // console.log("newVal !== oldVal")
      }
    },
    inpTree2 (newVal, oldVal) {
      // console.log("inpTree2 (watch)")
      if (newVal !== oldVal) {
        // console.log("newVal !== oldVal")
      }
    }
  },
  created () {
    this.listStructures()
  },
  methods: {
    flatTab (array) {
      let result = []
      const test = this;
      array.forEach(function (a) {
        result.push(a)
        if (Array.isArray(a.children)) {
          result = result.concat(test.flatTab(a.children))
        }
      })
      return result
    },
    listStructures () {
      // console.log("listStructures")
      // Recheche des données dans Cocktail (EM) => A tester après
      /* this.loading = true
      axios
          .get('https://ccc.bordeaux-inp.fr/annuaire/dev/server.pl', {
            params: {
              fqdn: 'ccc.bordeaux-inp.fr',
              operation: 'liste_structures',
              _proxy_methode: 'liste_structures',
            },
            responseType: 'text',
            crossDomain: true,
            withCredentials: true
          })
          .then(response => (this.results = response.data))
          .catch((error) => {
            this.error = true
            console.log('Development mode')
            console.log('Impossible de charger les données depuis Cocktail')
            console.log(error)
          })
          .finally(() => {
            this.loading = false
          })
      console.log(this.results) */

      if (this.prod) {
        // Production
        // Import des données depuis le fichier JSON (EM)
        console.log('Production mode (methods)')
        axios
            .get('https://ccc.bordeaux-inp.fr/annuaire/inp-tree.json')
            .then((response) => {
              this.inpTree = response
              this.inpTree2 = this.inpTree.data.children
              console.log('Chargement du fichier JSON')

            })
            .catch((error) => {
              this.error = true
              console.log('Impossible de charger le fichier JSON')
              console.log(error)
            })
      }
      else {
        // Development
        console.log('Development mode (methods)')
        this.inpTree2 = this.inpTreeTmp.children
        console.log('Chargement des données locales')
      }

      console.log("prod : " + this.prod)
      //console.log(this.inpTree2)
    },
    searchSn () {
      this.givenname = ''

      if (this.sn != '') {
        // Recherche des données dans le LDAP (EM)
        this.flagSearchUnit = false
        axios
            .post('https://ccc.bordeaux-inp.fr/signature_rs/ent-search.php', {
              directory: this.directory,
              sn: this.sn,
            })
            .then((response) => {
              this.results = response.data
              console.log(this.results.data)
              this.results.data.sort((a, b) => (a.cn > b.cn ? 1 : -1))
              this.resultsFinal = this.results.data
          })
        }
        else {console.log('searchSn : tentative de recherche gloable')}
    },
    searchGn () {
      this.sn = ''

      if (this.givenname != '') {
        // Recherche des données dans le LDAP (EM)
        this.flagSearchUnit = false
        axios
            .post('https://ccc.bordeaux-inp.fr/signature_rs/ent-search.php', {
              directory: this.directory,
              givenname: this.givenname,
            })
            .then((response) => {
              this.results = response.data
              //console.log(this.results.data)
              this.results.data.sort((a, b) => (a.cn > b.cn ? 1 : -1))
              this.resultsFinal = this.results.data
          })
        } 
        else {console.log('searchGn : tentative de recherche gloable')} 
    },
    searchUnit (unit) {
      console.log("searchUnit(" + unit + ")")
      this.flagSearchUnit = true
      this.givenname = ''
      this.sn = ''
      this.unit = unit
      this.resultsUnit = []
      let members = []

      //let unitSansAccent = this.strNoAccent(unit)

      // Recherche des données dans le LDAP (EM)
      /* axios
          .post('https://ccc.bordeaux-inp.fr/signature_rs/ent-search.php', {
            directory: this.directory,
            unit: unitSansAccent,
          })
          .then((response) => {
            this.results = response.data
            //console.log(this.results)
            this.results.data.sort((a, b) => (a.cn > b.cn ? 1 : -1))
          }) */

      // Recherche des données dans Cocktail (EM)
      // 1- Recherche de la liste des membres dans Cocktail
      // console.log("Membres >> Cocktail")
      axios
          .get('https://ccc.bordeaux-inp.fr/annuaire/server.pl', {
            params: {
              fqdn: 'ccc.bordeaux-inp.fr',
              operation: 'recherche_membres_new',
              structure: unit,
              _proxy_methode: 'recherche_membres_new',
            },
            responseType: 'text',
            crossDomain: true,
            withCredentials: true
          })
          .then((response) => {
            console.log(response.data)
            if (response.data == "-1") {
              this.resultsUnit = []
            }
            else {
              //console.log('response.data != "-1"')
              members = response.data.split(" ")

              members.forEach((element) => { // TODO : placer la requête 2 dans une fonction afin de la sortir de la requête 1
                // 2- Recherche des coordonées individuelles dans le LDAP (EM)
                // console.log("Coordonées individuelles >> LDAP")
                // console.log(element)
                axios
                    .post('https://ccc.bordeaux-inp.fr/signature_rs/ent-search.php', {
                      directory: this.directory,
                      id: element,
                    })
                    .then((response) => {
                      if (typeof response.data.data[0] === 'undefined') { 
                        console.log('ID non trouvé : ' + element)
                      }
                      else {
                        this.resultsUnit.push(response.data.data[0])
                        this.resultsUnit.sort((a, b) => (a.cn > b.cn ? 1 : -1)) // On trie dans la boucle pour rester dans axios (asynchronous) (EM)
                        //console.log(this.resultsUnit)
                        this.resultsFinal = this.resultsUnit
                      }
                    })
                    .catch((error) => {
                      this.error = true
                      //Autre erreur
                      console.log(error)
                    })
              })
            }
          })
          .catch((error) => {
              this.error = true
              //Erreur serveur interne:failed to connect to bbb.bordeaux-inp.fr:1235: Connection refused,IO::Socket::IP configuration failed
              console.log(error)
          })
    },
    onClickChild (value) { // Non utilisé ? (EM)
      //console.log("organigramme " + value)
      //console.log("Child : " + value);
      this.results = value
    },
    reset () { // Non utilisé ? (EM)
      this.success = false
      this.error = false
    },
    strNoAccent (a) {
      return a.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
    }
  }
}
</script>

<style>

@import url('https://fonts.googleapis.com/css2?family=Roboto+Condensed&display=swap');

html, body {
  font-family: 'Roboto', sans-serif;
}

* {
  font-family: 'Roboto', sans-serif;
}

form.zsearch, div.zresults {
  background-color: #e2f7fe;
  padding-top: 10px;
  padding-bottom: 10px;
  margin: 15px;
  box-shadow: rgba(149,157,165,0.2) 0px 8px 24px;
  border-radius: 6px;
}

ul {
  list-style-type:none;
  text-align: left;
}

.btn-link {
  color: #0bbbef !important;
}
.btn-link:hover {
  font-weight: bold;
}

.btn-success {
  color: #fff;
  background-color: #2A2E46 !important;
  border-color: #2A2E46 !important;
}
.btn-success:hover {
  background-color: #007970 !important;
  border-color: #007970 !important;
}

.btn-primary {
  color: #fff;
  background-color: #2A2E46 !important;
  border-color: #2A2E46 !important;
}
.btn-primary:hover {
  background-color: #0bbbef !important;
  border-color: #0bbbef !important;
}

</style>